function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

var Config = /*#__PURE__*/function () {
  function Config(data) {
    this.data = data;
  }
  var _proto = Config.prototype;
  _proto.extract = function extract(item) {
    var NullObjectConfig = {
      name: '',
      source: '',
      strategy: ''
    };
    var config;
    try {
      var _item$textContent;
      var nodeText = (_item$textContent = item.textContent) == null ? void 0 : _item$textContent.trim();
      config = _extends({
        name: item.getAttribute('name')
      }, JSON.parse(nodeText));
    } catch (ex) {
      config = NullObjectConfig;
    }
    return config;
  };
  _proto.get = function get() {
    return this.data.map(this.extract);
  };
  return Config;
}();

var Strategy;
(function (Strategy) {
  Strategy["Scroll"] = "scroll";
  Strategy["Click"] = "click";
  Strategy["Subtree"] = "subtree";
  Strategy["Visibility"] = "visibility";
  Strategy["Timeout"] = "timeout";
  Strategy["Immediate"] = "immediate";
})(Strategy || (Strategy = {}));
var BaseStrategy = /*#__PURE__*/function () {
  function BaseStrategy(parameters) {
    this.config = parameters.config;
    this.root = parameters.root;
    this.script = parameters.script;
  }
  var _proto = BaseStrategy.prototype;
  _proto.setup = function setup(handler) {
    handler(this.script);
  };
  return BaseStrategy;
}();

var Click = /*#__PURE__*/function (_BaseStrategy) {
  _inheritsLoose(Click, _BaseStrategy);
  function Click(parameters) {
    var _this;
    _this = _BaseStrategy.call(this, parameters) || this;
    _this.el = document.querySelector("" + _this.config.element) || document;
    return _this;
  }
  var _proto = Click.prototype;
  _proto.setup = function setup(handler) {
    var _this2 = this;
    this.el.addEventListener('click', function () {
      return handler(_this2.script);
    }, {
      once: true
    });
  };
  return Click;
}(BaseStrategy);

var Scroll = /*#__PURE__*/function (_BaseStrategy) {
  _inheritsLoose(Scroll, _BaseStrategy);
  function Scroll() {
    return _BaseStrategy.apply(this, arguments) || this;
  }
  var _proto = Scroll.prototype;
  _proto.setup = function setup(handler) {
    var _this = this;
    document.addEventListener('scroll', function () {
      return handler(_this.script);
    }, {
      once: true
    });
  };
  return Scroll;
}(BaseStrategy);

var Subtree = /*#__PURE__*/function (_BaseStrategy) {
  _inheritsLoose(Subtree, _BaseStrategy);
  function Subtree() {
    var _this;
    _this = _BaseStrategy.apply(this, arguments) || this;
    _this.main = document.querySelector('#main');
    return _this;
  }
  var _proto = Subtree.prototype;
  _proto.setup = function setup(handler) {
    var _this2 = this;
    if (!this.main) return;
    var observerInstance = new MutationObserver(function (mutationList, observer) {
      mutationList.forEach(function (mutation) {
        var observedElement = mutation.target.querySelector("" + _this2.config.element);
        if (!observedElement) {
          return;
        }
        handler(_this2.script);
        observer.disconnect();
      });
    });
    observerInstance.observe(this.main, {
      subtree: true,
      childList: true
    });
  };
  return Subtree;
}(BaseStrategy);

var Timeout = /*#__PURE__*/function (_BaseStrategy) {
  _inheritsLoose(Timeout, _BaseStrategy);
  function Timeout() {
    return _BaseStrategy.apply(this, arguments) || this;
  }
  var _proto = Timeout.prototype;
  _proto.setup = function setup(handler) {
    var _this = this;
    window.setTimeout(function () {
      return handler(_this.script);
    }, this.config.timeout);
  };
  return Timeout;
}(BaseStrategy);

var Visibility = /*#__PURE__*/function (_BaseStrategy) {
  _inheritsLoose(Visibility, _BaseStrategy);
  function Visibility() {
    var _this;
    _this = _BaseStrategy.apply(this, arguments) || this;
    _this.observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };
    return _this;
  }
  var _proto = Visibility.prototype;
  _proto.setup = function setup(handler) {
    var _this2 = this;
    var target = document.querySelector("" + this.config.element);
    if (!target) return;
    var observerInstance = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio <= 0) {
          return;
        }
        handler(_this2.script);
        observer.unobserve(target);
      });
    }, this.observerOptions);
    observerInstance.observe(target);
  };
  return Visibility;
}(BaseStrategy);

var Immediate = /*#__PURE__*/function (_BaseStrategy) {
  _inheritsLoose(Immediate, _BaseStrategy);
  function Immediate() {
    return _BaseStrategy.apply(this, arguments) || this;
  }
  var _proto = Immediate.prototype;
  _proto.setup = function setup(handler) {
    handler(this.script);
  };
  return Immediate;
}(BaseStrategy);

function createStrategy(parameters) {
  var strategy;
  switch (parameters.config.strategy) {
    case Strategy.Scroll:
      {
        strategy = new Scroll(parameters);
        break;
      }
    case Strategy.Click:
      {
        strategy = new Click(parameters);
        break;
      }
    case Strategy.Subtree:
      {
        strategy = new Subtree(parameters);
        break;
      }
    case Strategy.Visibility:
      {
        strategy = new Visibility(parameters);
        break;
      }
    case Strategy.Timeout:
      {
        strategy = new Timeout(parameters);
        break;
      }
    /**
     * @fallthrough
     * Intentional fallthrough
     * In both cases, whether the plugin is configured to be loaded immediately,
     * or if a strategy is not provided, the third party code is loaded immediately.
     */
    case Strategy.Immediate:
    default:
      strategy = new Immediate(parameters);
  }
  strategy.type = parameters.config.strategy;
  return strategy;
}

var Loader = /*#__PURE__*/function () {
  function Loader(parameters) {
    this.root = parameters.root;
  }
  var _proto = Loader.prototype;
  _proto.createNode = function createNode(config) {
    var identifier = config.name + "-deferred";
    var script = document.createElement('script');
    script.id = identifier;
    script.src = config.source;
    script.async = config.async || true;
    script.defer = config.defer || false;
    script.crossOrigin = 'anonymous';
    return {
      script: script,
      config: config
    };
  };
  _proto.insertNode = function insertNode(script) {
    this.root.appendChild(script);
  };
  _proto.configure = function configure(_ref) {
    var script = _ref.script,
      config = _ref.config;
    var parameters = {
      config: config,
      root: this.root,
      script: script
    };
    var strategy = createStrategy(parameters);
    strategy.setup(this.insertNode.bind(this));
  };
  return Loader;
}();

function load(thirdPartyScriptsConfig) {
  var root = window.document.body;
  if (!root) return;
  var loader = new Loader({
    root: root
  });
  thirdPartyScriptsConfig.filter(function (item) {
    return item.name && item.strategy && item.source;
  }).map(function (config) {
    return loader.createNode(config);
  }).forEach(function (item) {
    if (!item || Object.keys(item).length !== 2) return;
    loader.configure(item);
  });
}
function init() {
  var timerId = setTimeout(function () {
    var data = Array.from(document.querySelectorAll('[data-sisyphus-enabled="true"]') || []);
    var config = new Config(data);
    var thirdParties = config.get();
    if (thirdParties != null && thirdParties.length) {
      load(thirdParties);
    }
    clearTimeout(timerId);
  }, 0);
}

export default init;
export { load };
//# sourceMappingURL=sisyphus.esm.js.map
